import { useState } from 'react';
import { motion } from 'framer-motion';
import styles from './LogoImage.module.css'

import CodeAblaze from '../../assets/CodeAblaze.png';

function LogoImage() {
  const [clicked, setClicked] = useState(false);
  const variants = {
    stop: { y: [0, "-1rem", 0], transition: { repeat: Infinity, repeatDelay: 3 } }
  };

  return (
    <motion.div
      variants={variants}
      animate={''}
    >
      <div className={styles.LogoImage}
        onMouseLeave={() => {
          setClicked(false);
        }}
        onClick={() => {
          setClicked(true);
        }}
      >
        <div className={clicked ? styles.InfoTextExpand : styles.InfoText}>
          <div className={styles.InfoTextHolder}>
            CodeAblaze is a Leigh High School-based project dedicated to inspiring the spark among young minds in the computer science field, founded by Cameron Jiang and Audrey Huynh
            <br />
          </div>
        </div>
        <div className={styles.ImageContainer}>
          <img src={CodeAblaze} alt='logo' />
        </div>
      </div>
    </motion.div >
  );
}

export default LogoImage;
